export default "__VITE_ASSET__DZf36Ru9__"